import React, { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

// The Beacon Blueprint: big picture PDF (features, costs, limits, protection). Not the in-app how to Guide.
export const BlueprintDownload = ({ testid = "beacon-blueprint-download", className = "" }) => {
  const [busy, setBusy] = useState(false);
  const get = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/beacon/blueprint-pdf", { responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(data);
      a.download = "Beacon-Blueprint-v2.pdf";
      a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 2000);
    } catch { toast.error("Couldn't download the Blueprint, please try again."); } finally { setBusy(false); }
  };
  return (
    <button onClick={get} disabled={busy} data-testid={testid}
      className={`w-full flex items-center gap-3 border border-[#A855F7]/40 bg-[#A855F7]/[0.06] hover:bg-[#A855F7]/[0.12] transition-colors p-3 text-left disabled:opacity-60 ${className}`}>
      {busy ? <Loader2 size={20} className="text-[#C084FC] animate-spin shrink-0" /> : <FileDown size={20} className="text-[#C084FC] shrink-0" />}
      <span className="flex-1"><span className="block font-body text-sm font-semibold text-white">Download the Beacon Blueprint</span>
        <span className="block font-body text-xs text-zinc-400">The big picture in one PDF: everything a Beacon and Hearth can do, costs, honest limits and how your work is protected</span></span>
    </button>
  );
};
